import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Box } from 'core/components';
import VerticalDetailTabs from 'app/components/detailTabs/VerticalDetailTabs';
import TabbedChart from 'app/components/tabbedChart/TabbedChart';
import Page from 'app/components/page/Page';
import AggregateViewHeader from '../aggregate/AggregateViewHeader';
import parentLinks from '../NetworkExplorerParentLink';

@inject('$dictionary', '$tabs')
@observer
class InetFamilyDetails extends Component {
  constructor(props) {
    super(props);

    const { $tabs } = props;
    const tabs = $tabs.getTabs();

    this.state.tabBlacklist = [tabs.INET_FAMILY.id];
  }

  state = {
    filters: [],
    lookback_seconds: 86400,
    aggregateType: 'p95th_bits_per_sec'
  };

  get inetFamily() {
    const { match } = this.props;
    return match.params.inetFamily;
  }

  get inetFamilyLabel() {
    const { $dictionary } = this.props;
    return $dictionary.get('queryFilters.options.inet_family', {})[this.inetFamily] || this.inetFamily;
  }

  get filters() {
    const { filters } = this.state;
    const detailFilter = {
      filterField: 'inet_family',
      filterValue: this.inetFamily
    };

    return filters.concat(detailFilter);
  }

  handleFiltersApply = (filters) => {
    this.setState({ filters });
  };

  handleLookbackChange = (lookback_seconds) => {
    this.setState({ lookback_seconds });
  };

  handleAggregationChange = (aggregateType) => {
    this.setState({ aggregateType });
  };

  render() {
    const { aggregateType, filters, lookback_seconds, tabBlacklist } = this.state;

    return (
      <Page
        title={this.inetFamilyLabel}
        parentLinks={[...parentLinks, { link: '/v4/core/quick-views/inetFamily', label: 'INET Families' }]}
        scrolls
        showExport
      >
        <AggregateViewHeader
          title={this.inetFamilyLabel}
          aggregateType={aggregateType}
          filters={filters}
          lookbackSeconds={lookback_seconds}
          onFiltersChange={this.handleFiltersApply}
          onAggregateChange={this.handleAggregationChange}
          onMetricsChange={this.handleAggregationChange}
          onTimeRangeChange={this.handleLookbackChange}
        />

        <Box mb={2}>
          <TabbedChart overrides={{ lookback_seconds, aggregateTypes: [aggregateType] }} simpleFilters={this.filters} />
        </Box>

        <VerticalDetailTabs
          blacklist={tabBlacklist}
          simpleFilters={this.filters}
          queryOverrides={{ lookback_seconds, aggregateTypes: [aggregateType] }}
        />
      </Page>
    );
  }
}

export default InetFamilyDetails;
